import config from '../config'
import { authRequest } from '../request'

const base = `${config.mainApi}/sandbox/benefit-platforms`

export type SandboxPlatform = {
  id: number
  code: string
  name: string
  clientId: string
  platformEnabled: boolean
}

export type SandboxEntitlement = {
  id: number
  benefitPlatformId: number
  phoneNumber: string
  entitlementKey: string
  availableQuantity: number
  expiresAt: string | null
  enabled: boolean
  createdAt: string
  updatedAt: string
}

export type SandboxEntitlementRequest = Omit<SandboxEntitlement, 'id' | 'createdAt' | 'updatedAt'>

export const listSandboxPlatforms = () =>
  authRequest.get<MISSING_TYPE, SandboxPlatform[]>(`${base}/platforms`)

export const createSandboxEntryLink = (id: number) =>
  authRequest.post<MISSING_TYPE, { url: string; expiresAt: string }>(
    `${base}/platforms/${id}/entry-link`,
  )

export const listSandboxEntitlements = (params?: { platformId?: number; phoneNumber?: string }) =>
  authRequest.get<MISSING_TYPE, SandboxEntitlement[]>(`${base}/entitlements`, { params })

export const createSandboxEntitlement = (data: SandboxEntitlementRequest) =>
  authRequest.post<MISSING_TYPE, SandboxEntitlement>(`${base}/entitlements`, data)

export const updateSandboxEntitlement = (id: number, data: SandboxEntitlementRequest) =>
  authRequest.put<MISSING_TYPE, SandboxEntitlement>(`${base}/entitlements/${id}`, data)

export const deleteSandboxEntitlement = (id: number) =>
  authRequest.delete<MISSING_TYPE, void>(`${base}/entitlements/${id}`)
